import { Link } from "react-router-dom";

import {
  Button,
  Container,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconHeart } from "@tabler/icons-react";

export function ContactThanks() {
  return (
    <Container size="sm">
      <Stack gap="md" align="center" ta="center" py="xl">
        <ThemeIcon size={72} radius="xl" variant="light" color="blossom">
          <IconHeart size={36} />
        </ThemeIcon>
        <Title order={1}>Efharistó!</Title>
        <Text size="lg" c="dimmed" maw={520}>
          Thanks for your message - we&apos;ll get back to you as soon as we
          can.
        </Text>
        <Button
          component={Link}
          to="/"
          mt="md"
          size="md"
          radius="xl"
          color="sea"
        >
          Back to home
        </Button>
      </Stack>
    </Container>
  );
}

export default ContactThanks;
